// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.SatelliteWebLandlordWarningsHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  SatelliteWebLandlordWarningsHandler_getUserWarnings,
  SatelliteWebLandlordWarningsHandler_getUserWarnings_Path,
} from '@zg-rentals/ts-satellite-client';

import type { SatelliteWebLandlordUserWarningsResponseDto } from '@zg-rentals/ts-satellite-client';

export type SatelliteWebLandlordWarningsHandler_getUserWarnings_Options = UseQueryOptions<
  SatelliteWebLandlordUserWarningsResponseDto,
  unknown,
  SatelliteWebLandlordUserWarningsResponseDto,
  Array<string>
>;

const SatelliteWebLandlordWarningsHandler_getUserWarnings_GetKey = () => [
  SatelliteWebLandlordWarningsHandler_getUserWarnings_Path,
];

/**
 * Get user warnings for personal contact details and external links
 */
export const useSatelliteWebLandlordWarningsHandler_getUserWarnings = ({
  httpClient,
  ...options
}: Omit<SatelliteWebLandlordWarningsHandler_getUserWarnings_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: SatelliteWebLandlordWarningsHandler_getUserWarnings_GetKey(),
    queryFn: () => SatelliteWebLandlordWarningsHandler_getUserWarnings(httpClient),
  });
};
useSatelliteWebLandlordWarningsHandler_getUserWarnings.getKey =
  SatelliteWebLandlordWarningsHandler_getUserWarnings_GetKey;
